import axios from "axios";
import authHeader from "./auth-header";
import Config from "../config/index";

class SidebarService {
    async getSidebar() {
        const response = await axios.post(
            Config.apiPortalBasePath + "/fetchAllSidebarContent", null, {
            headers: {
                "Content-Type": "application/json",
                ...authHeader(),
            },
        }
        );
        return response;
    }

    async updateSidebar(sidebarData) {
        if (sidebarData === null || sidebarData === undefined) {
            return new Promise((resolve, reject) => {
                reject("Data is empty");
            });
        } else {
            const response = await axios.post(
                Config.apiBasePath + "/saveAllSidebarContent",
                sidebarData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        ...authHeader(), // Add your authentication headers here if needed
                    },
                }
            );
            return response;
        }
    }

    async deleteSidebar(sidebarData) {
        if (sidebarData === null || sidebarData === undefined) {
            return new Promise((resolve, reject) => {
                reject("Data is empty");
            });
        } else {
            const response = await axios.post(
                Config.apiBasePath + "/deleteSidebarContent",
                sidebarData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        ...authHeader(), // Add your authentication headers here if needed
                    },
                }
            );
            return response;
        }
    }
}

export default new SidebarService();
